export const AMOUNT_ERROR = "amount_error";
export const LIMIT_PRICE_ERROR = "limit_price_error";
export const TRIGGER_PRICE_ERROR = "trigger_price_error";
